// src/screens/pass/PassPurchaseBlock.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Button, Group, NumberInput, Paper, Text } from "@mantine/core";

function formatCurrency(value) {
  try {
    return new Intl.NumberFormat("en-AU", {
      style: "currency",
      currency: "AUD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `$${Number(value || 0).toFixed(2)}`;
  }
}

export default function PassPurchaseBlock({
  nights,
  setNights,
  nightlyRate,
  maxDuration,
}) {
  const effectiveMax = useMemo(() => Math.max(1, Number(maxDuration || 1)), [maxDuration]);
  const [textVal, setTextVal] = useState(String(nights || 1));

  useEffect(() => {
    const initial = Math.min(Math.max(Number(nights || 1), 1), effectiveMax);
    setNights(initial);
    setTextVal(String(initial));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const clamped = Math.min(Math.max(Number(nights || 1), 1), effectiveMax);
    if (clamped !== nights) setNights(clamped);
    setTextVal(String(clamped));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nights, effectiveMax]);

  function applyText(v) {
    const digits = String(v || "").replace(/\D+/g, "");
    if (!digits) return;
    const n = Math.min(Math.max(Number(digits), 1), effectiveMax);
    setNights(n);
    setTextVal(String(n));
  }

  return (
    <Paper radius="lg" p="md" withBorder>
      <Text fw={600} size="sm">
        Duration
      </Text>

      <Group mt="sm" justify="space-between" align="center" wrap="nowrap">
        <Button
          variant="light"
          onClick={() => setNights((n) => Math.max(1, Number(n || 1) - 1))}
          disabled={Number(nights || 1) <= 1}
        >
          –
        </Button>

        <NumberInput
          value={textVal}
          onChange={(v) => setTextVal(String(v ?? ""))}
          onBlur={() => applyText(textVal)}
          hideControls
          styles={{ input: { textAlign: "center" } }}
        />

        <Button
          variant="light"
          onClick={() => setNights((n) => Math.min(effectiveMax, Number(n || 1) + 1))}
          disabled={Number(nights || 1) >= effectiveMax}
        >
          +
        </Button>

        <Text>
          Night{Number(nights || 1) === 1 ? "" : "s"}
        </Text>
      </Group>

      <Group mt="md" justify="space-between">
        <Text size="sm" c="dimmed">
          Nightly rate
        </Text>
        <Text size="sm" fw={600}>
          {formatCurrency(Number(nightlyRate || 0))}
        </Text>
      </Group>
    </Paper>
  );
}
